<template>
<div>
	<modal-dialog
		:modal-visible="visible"
		title="Add Labour Task"
		confirm-button-text="Add"
		:submit-visible="true"
		modal-size="modal-lg"
		v-on:confirm="addTasks"
		v-on:closeModal="close">

		<div v-for="(task,index) in payload" :key="task.id+'_'+index" class="row">
			<div :class="{'col-sm-12':disableQty,'col-md-5':!disableQty}">
				<field v-if="task.findType != 'manual'" 
					label="Labour Task" 
					col-class="col-4" 
					:params="{type:'text',placeholder: 'Labour Task'}" 
					:readonly="true" 
					:value="task.description">
				</field>

				<field v-else
					label="Labour Task"
					col-class='col-4'
					:params="{type:'text',placeholder:'Labour Task',required:task.qty > 0 ? true : false}"
					v-model="task.description">
				</field>

			</div>
			<div v-if="!disableQty" class="col-md-3">
				<field 
					label="QTY"
					col-class="col-4" 
					:params="{type:'number',placeholder: 'QTY',step:0.05}"
					v-model="task.qty">
				</field>
				
			</div>
			<div v-else style="margin-top: 7px;margin-left: 5px">
				<i class="fa fa-trash icon-button" v-on:click="removeSelectedLabourAction(index)"></i>
			</div>
			
		</div>

		<field 
			class="mb-2"
			v-model="findType"
			:params="{type:'btn-group',buttons:typeButtons}"
			v-on:change="changeFindType">		
		</field>

		<categorized-list-record-selector 
			v-show="findType == 'browse' || findType == 'search'" 
			v-on:select="setTask"
			:is-labour-action="true"
			:suggested-records-ids="suggestedTasks"
			:type="findType">
		</categorized-list-record-selector>

	</modal-dialog>

</div>
</template>
<script type="text/javascript">
import CategorizedListRecordSelector from "@/components/super_components/CategorizedListRecordSelector"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import TableList from "@/components/TableList"

export default {
	components: {
		CategorizedListRecordSelector,
		ModalDialog,
		Field,
		TableList
	},
	props: [
		"visible",
		"disableManual",
		"disableQty",
		"suggestedTasks"
	],
	data() {
		return {
			findType: false,
			selectedTask: null,
			taskFound: false,
			selectedTaskIsManual: false,
			payload: [], /*{
								id: null,
								description: null,
								labour_hrs: null,
								qty: 0
							}*/
			fields: [
				{label: "Description",key:"description"},
				{label: "Category", key: "parentCategoryName"}
			]
		}
	},
	computed: {
		typeButtons() {
			let buttons = [
				{text: 'Search',icon:'fa-search',value:'search'},
				{text: 'Browse',icon:'fa-tags',value:'browse'},
			]

			if (!this.disableManual)
				buttons.push({text: 'Add Task Manually',icon:'fa-pencil-alt',value:'manual'})

			return buttons
		}
	},
	methods: {
		rand() {
			return Math.random()
		},
		mutateTasks(tasks) {
			return tasks.map(task => {

				task.parentCategoryName = task.LabourActionCategory.name

				return task
			})
		},
		changeFindType() {
			let vm = this

			this.$nextTick(() => {
				if (vm.findType == 'manual') {
					vm.taskFound = true
					vm.payload.push({
						description: "",
						findType: 'manual',
						qty: 1,
						labour_hrs: 0,
						id: this.rand()
					})
					this.selectedTaskIsManual = true
				}
				else
					vm.taskFound = false
			})
		},
		setTask(task) {
			let selectedTask = JSON.parse(JSON.stringify(task))

			if ("id" in selectedTask)
				this.selectedTaskIsManual = false
			else
				this.selectedTaskIsManual = true

			let catName = ""
			if ("LabourActionCategory" in selectedTask && "name" in selectedTask.LabourActionCategory)
				catName = selectedTask.LabourActionCategory.name

			//check if this material already exists in payload
			let taskIndex = this.payload.findIndex(task => task.id == selectedTask.id)
			if (taskIndex >= 0) {
				this.payload[taskIndex].qty++
			}
			else {
				this.payload.push({
					id : selectedTask.id,
					qty : 1,
					description : selectedTask.description,
					categoryName: catName,
					labour_hrs: selectedTask.labour_hrs
				})
			}
			
			this.taskFound = true

			this.selectedTask = task
		},
		addTasks() {

			let vm = this

			let hasManualTask = this.payload.find(task => task.findType == 'manual')

			if (hasManualTask) {

				let description = this.payload.reduce((des,task) => {
					if (des)
						return des+", "+task.description
					else
						return task.description
				},"")

			}

			let payload = JSON.parse(JSON.stringify(this.payload))

			this.$emit("addTasks",payload)
			this.payload = []
			this.findType = null
			this.taskFound = false
		},
		removeSelectedLabourAction(index) {
			this.payload.splice(index,1)
		},
		close() {
			this.$emit("closeModal")
		},
	},
	created() {

	}
}
</script>